import { Box } from "@chakra-ui/layout";
import { Text } from "@chakra-ui/react";
import { FracaoForm } from "core/features/fracao/typings";
import colors from "core/resources/theme/colors";
import React from "react";
import { Control } from "react-hook-form";
import { BiEdit } from "react-icons/bi";
import Field from "../Field";

interface FormFracaoHeaderProps {
  control: Control<FracaoForm, object>;
  enabledEdit: boolean;
  onExcelInput: () => any;
  onEnableEdit: () => any;
  loading?: boolean;
}
function FormFracaoHeader({
  control,
  enabledEdit,
  onExcelInput,
  onEnableEdit,
  loading,
}: FormFracaoHeaderProps) {
  return loading ? (
    <Text>Carregando...</Text>
  ) : (
    <>
      <Field
        control={control}
        name="nome"
        rules={{ required: true }}
        inputProps={{
          disabled: !enabledEdit,
          placeholder: "Nome da fração",
          fontWeight: "bold",
          fontSize: 18,
          width: "200px",
          textDecoration: "underline",
          borderColor: "#00000000",
          _disabled: {
            background: "none !important",
            pointerEvents: "none",
          },
        }}
      />

      <Box mx={4} mt="7px">
        <BiEdit
          color={colors.primary}
          size={24}
          onClick={onEnableEdit}
          cursor="pointer"
          aria-label="Editar fração"
          aria-roledescription="Botão de editar fração"
          style={{ marginTop: "auto", marginBottom: "auto" }}
        />
      </Box>

      {/* <InputExcel onReadExcelFile={console.log} /> */}
    </>
  );
}

export default FormFracaoHeader;
